/**
 * @author vishwadeep.kapoor
 */
const validator = {
  username: {
    rules: [
      {
        test: /^[a-z0-9_]+$/,
        message: 'Username must contain only alphabets-numeric lowercase characters',
      },
      {
        test: (value) => (value.length > 2),
        message: 'Username must be longer than two characters',
      },
    ],
    errors: ['This field is required'],
    valid: false,
    state: '',
  },
  password: {
    rules: [
      {
        test: (value) => {
          // if (value.length <= 15 && value.length >= 8 && /[a-zA-Z]+/.test(value) && /\d+/.test(value)) {
          if (value.length) {
            return true;
          }
          return false;
        },
        message: 'Please enter valid password',
        // message: 'Password should be 8-15 characters long containing atleast one letter (a-z or A-Z) and one digit (0-9)',
      },
    ],
    errors: ['This field is required'],
    isFieldRequired: true,
    valid: false,
    state: '',
  },
  confirmPassword: {
    rules: [
      {
        test: (password, confirm_pass) => {
          if (password === confirm_pass) {
            return true;
          }
          return false;
        },
        message: 'Password and confirm password must be match',
      },
    ],
    errors: ['This field is required'],
    isFieldRequired: true,
    valid: false,
    state: '',
  },
  email: {
    rules: [
      {
        test: (value) => {
          if (value && value.includes('@') && (value.endsWith('.in') ||
            value.endsWith('.net') ||
            value.endsWith('.org') ||
            value.endsWith('.com') ||
            value.endsWith('.us') ||
            value.endsWith('.uk') ||
            value.endsWith('.info'))) {
            return true;
          }
          return false;
        },
        message: 'Please enter a valid email id',
      },
    ],
    errors: ['This field is required'],
    isFieldRequired: true,
    valid: false,
    state: '',
  },
  name: { /** @func utils.onlyStrings */
    rules: [
      {
        test: (value) => {
          if (value.length >= 5 && value.length <= 30) {
            return true;
          }
          return false;
        },
        message: 'Please enter a name between 5 and 30 characters',
      },
    ],
    errors: ['This field is required'],
    isFieldRequired: true,
    valid: false,
    state: '',
  },
  city: { /** @func utils.onlyStrings */
    rules: [
      {
        test: (value) => {
          if (value.length >= 2 && value.length <= 20) {
            return true;
          }
          return false;
        },
        message: 'Please enter city name',
      },
    ],
    errors: ['This field is required'],
    isFieldRequired: true,
    valid: false,
    state: '',
  },
  /**
   *  @func utils.onlyNumbers
   *  @param {maxLength={4}} input @argument props */
  phone: {
    rules: [
      {
        test: (value) => {
          if (/^[0-9]+$/.test(value) && value.length === 10) {
            return true;
          }
          return false;
        },
        message: 'Please enter a valid mobile number',
      },
    ],
    errors: ['This field is required'],
    isFieldRequired: true,
    valid: false,
    state: '',
  },
  zaggle_card: {
    rules: [
      {
        test: (value) => (value.length === 16 || value.length === 10),
        message: 'Please enter a valid card number',
      },
    ],
    errors: ['This field is required'],
    isFieldRequired: true,
    valid: false,
    state: '',
  },
  address: {
    rules: [
      {
        test: (value) => {
          if (value.length >= 10 && value.length <= 100) {
            return true;
          }
          return false;
        },
        message: 'Please enter address between 10 and 100 characters',
      },
    ],
    errors: ['This field is required'],
    isFieldRequired: true,
    valid: false,
    state: '',
  },
  state: { /** @func utils.onlyStrings */
    rules: [
      {
        test: (value) => {
          if (value.length >= 2 && value.length <= 20) {
            return true;
          }
          return false;
        },
        message: 'Please enter state name',
      },
    ],
    errors: ['This field is required'],
    isFieldRequired: true,
    valid: false,
    state: '',
  },
  zip_code: {
    rules: [
      {
        test: (value) => {
          // if (/^[0-9]+$/.test(value) && value.length === 6) { // To check numbers
          if (value.length >= 5 && value.length <= 10) {
            return true;
          }
          return false;
        },
        message: 'Please enter a valid ZipCode',
      },
    ],
    errors: ['This field is required'],
    isFieldRequired: true,
    valid: false,
    state: '',
  },
  number: {
    rules: [
      {
        test: (value) => {
          if (/^[0-9]*$/.test(value) && value.length <= 2) { // [1-9]+
            return true;
          }
          return false;
        },
        message: 'Please enter a valid number',
      },
    ],
    errors: ['This field is required'],
    isFieldRequired: true,
    valid: false,
    state: '',
  },
  otp: {
    rules: [
      {
        test: (value) => {
          if (/^[0-9]*$/.test(value) && (value.length === 6 || value.length === 4)) {
            return true;
          }
          return false;
        },
        message: 'Please enter the 6 digit otp Recieved on Your mobile',
      },
    ],
    errors: ['This field is required'],
    isFieldRequired: true,
    valid: false,
    state: '',
  },
  range: {
    rules: [
      {
        test: (value, min, max) => {
          if (/^[0-9]+$/.test(value) && value >= min && value <= max) {
            return true;
          }
          return false;
        },
        message: 'Value must be in between :min and :max', // message will be from the containor it self
      },
    ],
    errors: [],
    isFieldRequired: false,
    valid: false,
    state: '',
  },
  mandatory: {
    rules: [
      {
        test: (value) => {
          if (value) {
            return true;
          }
          return false;
        },
        message: 'This field is mandatory',
      },
    ],
    errors: ['This field is required'],
    isFieldRequired: true,
    valid: false,
    state: '',
  },
  time: {
    rules: [
      {
        test: (value) => {
          if (value) {
            return true;
          }
          return false;
        },
        message: 'Please select time',
      },
    ],
    errors: ['This field is required'],
    isFieldRequired: true,
    valid: false,
    state: '',
  },
  recaptcha: {
    rules: [
      {
        test: (value) => {
          if (value) {
            return true;
          }
          return false;
        },
        message: 'Please verify the Recaptcha',
      },
    ],
    errors: ['Please verify the Recaptcha'],
    isFieldRequired: true,
    valid: false,
    state: '',
  },
};

export default validator;
// {
//   test: /^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)/,
//   message: 'Should contain atleast one digit(0-9) and one character(a-z or A-Z)',
// },
// {
//   test: /\d+/,
//   message: 'Should contain atleast one digit (0-9)',
// },
// {
//   test: /[a-zA-Z]+/,
//   message: 'Should contain atleast one letter (a-z or A-Z)',
// },
// {
//   test: (value) => (value.length >= 8),
//   message: 'Please enter minimum 8 characters',
// },
// {
//   test: (value) => (value.length <= 15),
//   message: 'Maximum of 15 characters are allowed',
// },
// {
//   test: /^[A-Za-z]+$/,
//   message: 'Should contain Alphabets',
// },
// {
//   test: (value) => (value.length >= 5),
//   message: 'Please enter minimum 5 characters',
// },
// {
//   test: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/,
//   message: 'Please enter a valid email id',
// },



// WEBPACK FOOTER //
// client/devUtils/validations.js